<template>
  <section class="section section__content --centered">
    <SectionHeader v-if="content.header" :text="content.header" v-reveal />
    <CTABlock :content="content" :margin-top="false" />
  </section>
</template>

<script>
import { CTABlock } from '@/components/blocks'
import { SectionHeader } from '@/components/small'
import { DefaultSectionProps } from '@/mixins'

export default {
  name: 'CTASection',
  mixins: [DefaultSectionProps],
  components: { CTABlock, SectionHeader },
}
</script>
